<template>
  <div>
    <b-card-actions
      v-for="(zone, zoneId) in zones"
      :key="zoneId"
      collapsed
      action-collapse
      :title="zone.city"
    >
      <b-form-group>
        <template
          v-for="config in CONFIGURATIONS"
        >
          <b-form-checkbox
            :key="config.text"
            v-model="zone.configurations[config.key]"
            class="mb-1"
          >
            {{ config.text }}
          </b-form-checkbox>
        </template>
      </b-form-group>
      <b-button
        variant="primary"
        @click="updateZoneConfigurations(zoneId)"
      >
        <span
          class="text-nowrap"
        >Save</span>
      </b-button>
    </b-card-actions>
  </div>
</template>

<script>
import {
  BFormCheckbox, BFormGroup, BButton,
} from 'bootstrap-vue'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import { reduce } from 'lodash/collection'
import { ref } from '@vue/composition-api'
import store from '@/store'

const CONFIGURATIONS = [
  { text: 'Scheduled Rides', key: 'scheduledEnabled' },
]

export default {
  components: {
    BFormCheckbox,
    BFormGroup,
    BButton,

    BCardActions,
  },
  setup() {
    const getZoneId = zone => `${zone.country}::${zone.city}`
    const zones = ref([])

    zones.value = reduce(store.getters['zones/zones'], (result, zone) => {
      // eslint-disable-next-line no-param-reassign
      result[getZoneId(zone)] = JSON.parse(JSON.stringify({ ...zone, configurations: { scheduledEnabled: zone?.configurations?.scheduledEnabled || false } }))
      return result
    }, {})

    console.log(zones, 'zones')
    return {
      CONFIGURATIONS,
      zones,
      getZoneId,
    }
  },
  methods: {
    async updateZoneConfigurations(zoneId) {
      const result = await this.$swal({
        title: 'Are you sure?',
        text: 'You want to apply this action?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, update it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
      if (result.value) {
        await store.dispatch('zones/updateZoneConfiguration', {
          zone: zoneId,
          configurations: this.zones[zoneId].configurations,
        })
        this.$swal({
          icon: 'success',
          title: 'Saved',
          text: 'Configuration has been updated!',
          customClass: {
            confirmButton: 'btn btn-success',
          },
        })
      }
    },
  },
}
</script>

  <style lang="scss" scoped>

  </style>
